import { atom, useAtom } from "jotai";

export interface DataFilter {
	folderId?: string | null;
	fileId?: string | null;
	noteId?: string | null;
	done?: boolean;
	date?: {
		after?: string;
		before?: string;
	};
}

export const dataFilterAtom = atom<DataFilter>({});

export const useDataFilter = () => {
	const [filter, setFilter] = useAtom(dataFilterAtom);

	return [filter, setFilter] as const;
};
